import React, { FC, useMemo } from 'react';
import UserNotificationsContext, {
  IUserNotificationsContext,
} from 'common/contexts/UserNotificationsContext';

interface IUserNotificationsContextProvider extends IUserNotificationsContext {
  children: JSX.Element;
}

const UserNotificationsContextProvider: FC<IUserNotificationsContextProvider> = ({
  readUserNotification,
  readUserNotifications,
  readUserNotificationLoading,
  readUserNotificationsLoading,
  children,
}) => {
  const contextValue = useMemo((): IUserNotificationsContext => {
    return {
      readUserNotification,
      readUserNotifications,
      readUserNotificationLoading,
      readUserNotificationsLoading,
    };
  }, [
    readUserNotification,
    readUserNotifications,
    readUserNotificationLoading,
    readUserNotificationsLoading,
  ]);

  return (
    <UserNotificationsContext.Provider value={contextValue}>
      {children}
    </UserNotificationsContext.Provider>
  );
};

export default UserNotificationsContextProvider;
